<template>
  <div>
    <b-table responsive :class="['mb-3', tableClass]" head-variant="dark" borderless striped hover :items="items"
      :fields="fields" :filter="filter" @filtered="onTableFiltered" show-empty sort-icon-left>
      <template #empty>
        <div style="text-align: center">
          <span>{{ $t("Gral.noRegistros") }}</span>
        </div>
      </template>
      <template #emptyfiltered>
        <div style="text-align: center">
          <span>{{ $t("Gral.busquedaFallida") }}</span>
        </div>
      </template>

      <template v-for="(_, slotName) in $scopedSlots" #[slotName]="data">
        <slot :name="slotName" v-bind="data"></slot>
      </template>
    </b-table>

    <div class="d-flex justify-content-center">
      <b-pagination class="pagination-movil" v-model="localCurrentPage" :total-rows="totalRows" :per-page="perPage"
        @input="$emit('update:currentPage', localCurrentPage)" align="fill">
      </b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableClass: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 3,
    },
    filter: {
      type: String,
      default: "",
    },
    totalRows: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      localCurrentPage: this.currentPage,
    };
  },
  watch: {
    currentPage(newVal) {
      this.localCurrentPage = newVal;
    },
    localCurrentPage(newVal) {
      this.$emit("update:currentPage", newVal);
    },
  },
  methods: {
    onTableFiltered(filteredItems) {
      this.$emit("filtered", filteredItems.length);
    },
  },
};
</script>

<style>
@media (max-width: 959px) {
  .pagination-movil {
    width: 100%;
  }
}
</style>